export default __webpack_public_path__ + "static/media/iconArrowRight.bebc7c94.svg";